import { Grid, Breadcrumb, Text, Box, Flex } from "../components";
import styled from "styled-components";
import MainLayout from "../layouts/main";
import Heading from "../components/Heading";
import Image from "next/image";
import GammerImage from "public/images/what-gamer.png";
import useBreakpoint from "../hooks/useBreakpoint";
import KantanaImage from "public/images/partner-kantana.png";
import TrueImage from "public/images/partner-true.png";
import SiamDiscoveryImage from "public/images/partner-siamDiscovery.png";
import SynnexImage from "public/images/partner-synnex.png";
import CocacolaImage from "public/images/partner-cocacola.png";
import ThermaltakeImage from "public/images/partner-thermaltake.png";

const StyledWrapper = styled("div")`
  padding-top: 140px;
  font-family: "Noto Sans Thai", sans-serif;
`;

const StyledContainer = styled("div")`
  margin: 0 auto;
  max-width: 1440px;
  width: 90%;
`;

const StyledTitle = styled("div")`
  color: white;
  text-align: center;
  width: 100%;
  margin: 220px 0 140px 0;
  line-height: 0;
`;

const StyledImageContainer = styled("div")`
  width: 100%;
  img {
    object-fit: cover !important;
    width: 100% !important;
    position: relative !important;
    height: 280px !important;
  }
`;

const StyledText = styled(Text)``;

const StyledGrid = styled(Grid)`
  gap: 40px;
  img {
    width: 183px;
    height: auto;
  }
  grid-template-columns: repeat(3, 1fr);
`;

const StyledHeading = styled(Heading)`
  font-size: 40px;
  line-height: 50px;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  ${({ theme }) => theme.mediaQueries.xs} {
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.1em;
  }
`;

const StyledLightTopLeftImage = styled("img")`
  position: absolute;
  left: 6%;
`;

const StyledLightTopRightImage = styled("img")`
  position: absolute;
  right: 6%;
`;

const partners = [
  {
    url: TrueImage,
    alt: "True",
  },
  {
    url: SiamDiscoveryImage,
    alt: "siam-discovery",
  },
  {
    url: KantanaImage,
    alt: "Kantana",
  },
  {
    url: SynnexImage,
    alt: "synnex",
  },
  {
    url: CocacolaImage,
    alt: "coccola",
  },
  {
    url: ThermaltakeImage,
    alt: "themaltake",
  },
];
const WhatIsProhubPage = () => {
  const items = [
    { title: "Home", link: "/" },
    { title: "What’s Pro Hub", link: "/what-is-prohub" },
  ];

  const screens = useBreakpoint();
  return (
    <MainLayout bg="/images/what-bg.webp">
      <StyledWrapper>
        <StyledContainer>
          <Breadcrumb items={items} current="Tournament" />
          <StyledTitle>
            <Text
              fontWeight="700"
              fontSize={screens.xs ? "22px" : "42px"}
              lineHeight={screens.xs ? "27px" : "53px"}
              letterSpacing="0.2em"
              fontFamily="Orbitron"
            >
              True 5G
            </Text>
            <Text
              fontWeight="900"
              fontSize={screens.xs ? "51px" : "101px"}
              lineHeight={screens.xs ? "57px" : "96px"}
              letterSpacing="0.2em"
              fontFamily="Orbitron"
            >
              PRO HUB
            </Text>
            <StyledText
              fontSize={screens.xs ? "16px" : "24px"}
              lineHeight={screens.xs ? "21px" : "33px"}
              mt={screens.xs ? "26px" : "36px"}
              style={{ textShadow: "0px 4px 34px #011E4A" }}
            >
              พื้นที่แฮงค์เอาท์ของคนรุ่นใหม่ใจกลางเมือง
            </StyledText>
          </StyledTitle>

          <Box maxWidth="846px" m="0 auto" style={{ textAlign: "center" }}>
            <Text
              fontSize={screens.xs ? "24px" : "42px"}
              lineHeight={screens.xs ? "32p" : "57px"}
              fontWeight="700"
            >
              ดิจิทัลฮับสุดล้ำแห่งแรกในเอเชียตะวันออกเฉียงใต้
            </Text>
            <Text
              fontSize={screens.xs ? "14px" : "16px"}
              lineHeight={screens.xs ? "19px" : "21px"}
              mt={screens.xs ? "24px" : "20px"}
              letterSpacing="0.08em"
            >
              ศูนย์รวมเหล่าเกมเมอร์ ทั้งสมัครเล่นและมืออาชีพ ตอบโจทย์ 3
              ไลฟ์สไตล์คนรุ่นใหม่ เป็นจุดสร้าง Gamer หน้าใหม่ในวงการกีฬา
              E-Sports ศูนย์รวมไลฟ์สไตล์คน New Gen
              สู่การแสดงออกที่สร้างสรรค์ไร้ขอบเขต ทั้ง Cosplay, Anime, Board
              Game และศูนย์รวมทักษะใหม่ สู่มิติใหม่แห่งการเรียนรู้ แลกเปลี่ยน
              ฝึกฝนเพื่อพัฒนา และต่อยอดทักษะสู่โลกอนาคต
            </Text>
          </Box>

          <Box mt="96px" position="relative">
            {/* <StyledLightTopLeftImage
              src="/images/what-light-1.svg"
              alt="top-left-light"
            />
            <StyledLightTopRightImage
              src="/images/what-light-2.svg"
              alt="top-left-light"
            /> */}
            <Heading fontFamily="Orbitron" fontWeight="700">
              OUR PARTNER
            </Heading>
            <Flex justifyContent="center" alignItems="center">
              <StyledGrid>
                {partners.map((item) => (
                  <Image src={item.url} alt={item.alt} />
                ))}
              </StyledGrid>
            </Flex>
          </Box>
          <Box mt={screens.xs ? "100px" : "240px"}>
            <Heading
              style={{ display: "flex" }}
              fontFamily="Orbitron"
              fontWeight="700"
            >
              Immersive Discovery
            </Heading>
            <Flex style={{ gap: "59px" }} flexWrap="wrap">
              <Box style={screens.xs ? {} : { flex: 3 }}>
                <Text fontSize="16px" lineHeight="21px">
                  TRUE 5G PROHUB แบ่งพื้นที่ออกเป็น 5 โซน{" "}
                </Text>
                <ul>
                  <li>
                    <strong>Gaming Zone : </strong>
                    พื้นที่สำหรับเกมเมอร์และโปรเพลเยอร์ที่พรั่งพร้อมด้วยคอมพิวเตอร์
                    อุปกรณ์สำหรับการเล่นเกมและอินเตอร์เน็ตความเร็วสูง
                  </li>
                  <li>
                    <strong>Private VIP Zone : </strong>
                    พื้นที่สำหรับกลุ่ม ที่ต้องการความเป็นส่วนตัว
                  </li>
                  <li>
                    <strong>Arena Zone : </strong>พื้นที่จัดกิจกรรม การแข่งขัน
                    E-Sports, Live Studio, Watch Party
                  </li>
                  <li>
                    <strong>Future Skills Training Zone : </strong>
                    พื้นที่สำหรับการเรียนรู้ และพัฒนาทักษะในอนาคต
                  </li>
                  <li>
                    <strong>Food & Beverage Service : </strong>
                    พื้นที่สำหรับการพักผ่อน พร้อมบริการ อาหารและเครื่องดื่ม
                  </li>
                </ul>
              </Box>
              <Box style={{ flex: 5 }}>
                <img
                  src="/images/what-gamer.png"
                  alt="gammer"
                  style={{ maxWidth: "100%" }}
                />
                {/* <img src="/images/what-gamer.png" alt="Gamer" /> */}
              </Box>
            </Flex>
          </Box>
        </StyledContainer>
      </StyledWrapper>
    </MainLayout>
  );
};

export default WhatIsProhubPage;
